export default {
    meta: {
        title: '机会点表单',
        url: '/standardstore/chancepointlist',
        urlName: '标准版拓店-机会点',
    }
};
